export default __webpack_public_path__ + "319dc0528d98cadf6b48459b237366f5.png";